import script from "./form-three.vue?vue&type=script&setup=true&lang=js"
export * from "./form-three.vue?vue&type=script&setup=true&lang=js"

import "./form-three.vue?vue&type=style&index=0&id=3e2c0f20&scoped=true&lang=css"
import "./form-three.vue?vue&type=style&index=1&id=3e2c0f20&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e2c0f20"]])

export default __exports__